export const SYNC_CURRENT_USER = '@@currentUser/sync'

export const UPDATE_CURRENT_USER = '@@currentUser/update'
export const RESET_CURRENT_USER = '@@currentUser/reset'
export const SIGN_IN_CURRENT_USER = '@@currentUser/SignIn'
export const UPDATE_CURRENT_USER_ROLE = '@@currentUser/updateRole'

export const SET_CURRENT_USER = '@@currentUser/set'
